import React from "react";

export const Phone: React.FC<any> = () => (
	<>
		<g stroke="none" strokeWidth="1">
			<path
				d="M21.6835461,22.8830394 C21.2034689,23.6165682 20.3696465,24.0465679 19.4852922,23.9959801 C18.6009379,23.9453944 17.4639109,23.8189238 16.6806269,23.6165682 C13.1937447,22.7059809 9.58052622,20.5306874 6.52318716,17.4700973 C3.4658481,14.4095094 1.29286338,10.7924501 0.383241992,7.30186083 C0.181103965,6.51774315 0.0800349519,5.4048014 0.0042331249,4.51950754 C-0.0463013817,3.65950758 0.357974805,2.82480154 1.09072535,2.34421294 L4.19859905,0.270095058 C5.00715116,-0.261081502 6.09364352,0.0171538006 6.52318716,0.877154022 L9.04991383,5.75891938 C9.40365471,6.44186088 9.22678427,7.30186083 8.62036966,7.78244997 L6.34631619,9.55303877 C7.25593758,11.2477437 8.11502432,12.6136267 9.78266371,14.2577449 C11.3239678,15.8006863 12.6631323,16.7112736 14.4065729,17.6471558 L16.2005486,15.3453916 C16.6806269,14.7383335 17.5397152,14.53598 18.2219289,14.9153919 L23.1237778,17.4448023 C23.982864,17.8748042 24.2608048,18.9624499 23.7301913,19.7718636 L21.6835461,22.8830394 Z"
				clipRule="evenodd" fillRule="evenodd"
			></path>
		</g>
	</>
);

